import React, { useState} from "react";
import {
    Card,
    CardTitle,
    CardBody,
    Row,
    Col
} from "reactstrap";
import { motion } from "framer-motion";
import { checkServers } from '../redux/actions/rLink.action';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { apiServices } from '../redux/services/api.services';

const SChecker = (props) => {
    const regexName = /^[A-Za-z éàîïä '!0-9]{0,128}$/;
    const [name, setName] = useState('');
    const [currentSearch, setCurrentSearch] = useState('');
    const [servers, setServers] = useState([]);
    const handleSetRedeemCodeValue = (e) => {
        setName(e.target.value);
    }
    
    const checkBtn = () => {
        if (name === currentSearch) return setCurrentSearch('');
        if (!regexName.test(name))
            return toast.error('Your search term is is badly formatted');
        if (name.length < 5) 
            return toast.info('Your search term is too short');
        setCurrentSearch('');
        apiServices.post("/checkServer", {name}).then((res) => {
            if (res.data && res.data.success && res.data.data && res.data.data.length) {
                var result = [];
                res.data.data.forEach((element) => {
                    element.currentState = getSortState(element);
                    result.push(element)
                })
                result.sort((a, b) => a.currentState - b.currentState);
                setServers(result);
                setCurrentSearch(name);
            }
            if (res.data && res.data.code) {
                if (res.data.code === "EMPTY")
                    return toast.info(`This server isn't already pair from our service, you still can contact us on discord and ask us about the server`);
                else return toast.error('Error occured during the research');
            }
        }).catch(err => {
            return toast.error('Error occured during the research, contact the staff on discord');
        });
    }

    const getSortState = (serv, numeric = false) => {
        if (IsBlocked(serv.infos.name)) return 3;
        if (serv.unreachable) return 2;
        if (serv.userCount && serv.instance.lastAlive > (Math.floor(Date.now() / 1000) - 600)) return 0;
        else return 1;
    }

    const IsBlocked = (name) => {
        const blockedServers = ['rustoria', 'vital', 'rustspain', 'Repulsion'];
        for (const firm of blockedServers) {
            if (name.toLowerCase().includes(firm)) return true;
        }
        return false;
    }
    
    const IsFeaturesBlocked = (name) => {
        const featuresBlocked = [/*{
            server: 'rustopia',
            featuresBlocked: 'Events'
        }*/];
        for (const firm of featuresBlocked) {
            if (name.toLowerCase().includes(firm.server)) return firm.featuresBlocked;
        }
        return false;
    }

    const getServerState = (serv, numeric = false) => {
        if (serv.unreachable) return 'Unreachable';
        if (serv.userCount && serv.instance.lastAlive > (Math.floor(Date.now() / 1000) - 600)) return 'Connected';
        else return 'Ready';
    }
    
    const getError = () => {
        var error = false, color = false;
        if (name.length && !regexName.test(name)) {
            error = "Your search term is badly formatted";
            color = "red";
        } else if (name.length && name.length < 5) {
            error = "Your search term is too short";
            color = "orange";
        }
        if (error)
            return(<span class={`errors c-${color}`}>
                {error}
            </span>)
        else return (<></>)
    }

    const getServers = () => {
        return servers.map((serv, key) => {
            var isBlocked = IsBlocked(serv.infos.name);
            var blockedFeatures = IsFeaturesBlocked(serv.infos.name);
            var serverState = getServerState(serv);
            return(
            <Row className={`server ${isBlocked ? 'Blocked' : serverState}`}>
                <Col xs={blockedFeatures ? 5 : 8} className="name">
                    {serv.infos.name}
                </Col>
                {blockedFeatures && <Col xs="3" className="message">
                    {`${blockedFeatures} are disabled on the server.`}
                </Col>}
                <Col xs="4" className="state">
                    {isBlocked ? `Bots aren't allowed on this server` : serverState}
                </Col>
            </Row>);
        });
      };
    return (
        <div className="serverCheckerContainer">
            <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                <Card className="serverChecker">
                    <CardTitle>Server checker</CardTitle>
                    <CardBody>
                        <div className="searchInput">
                            <input placeholder="Server name" value={name} onChange={handleSetRedeemCodeValue} type="text" />
                            <motion.div whileTap={{ scale: 0.97}}>
                                <button onClick={() => checkBtn()}>{name === currentSearch ? currentSearch ? 'Close' : 'Check' : 'Check'}</button>
                            </motion.div>
                        </div>
                        {getError()}
                        {currentSearch && servers.length > 0 && <div className="searchResult">
                            {getServers()}
                        </div>}
                    </CardBody>
                </Card>
            </motion.div>
        </div>
    );
};

const mapDispatchToProps = {
    checkServers
};

export default connect(null, mapDispatchToProps)(SChecker);